module.exports = __webpack_public_path__ + "img/B-771-790.96600d15.svg";